module.exports = __webpack_public_path__ + "img/icon-time.9ca4c95e.svg";